import { useBusinessEntitiesOfCompany } from '@commenda/api';
import {
  InputErrorMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { IBusinessEntity } from '@commenda/types';
import { ReactNode } from 'react';
import { MoleculeCard } from '../helpers/MoleculeCard';
import { MoleculeCardTitle } from '../helpers/MoleculeCardTitle';

type SelectEntityDropdownProps = {
  title: string;
  description?: string;
  helperAlert?: ReactNode;
  companyId: number;
  onSelectBusinessEntity: (businessEntity: IBusinessEntity) => void;
  selectedBusinessEntity: IBusinessEntity;
  hideEntities?: number[];
  disabled?: boolean;
  error?: string;
};
export function SelectEntityDropdown({
  title,
  description,
  helperAlert,
  companyId,
  onSelectBusinessEntity,
  selectedBusinessEntity,
  hideEntities,
  disabled,
  error,
}: SelectEntityDropdownProps) {
  const {
    data: businessEntities,
    error: businessEntitiesError,
    isLoading,
  } = useBusinessEntitiesOfCompany(companyId);

  return (
    <MoleculeCard>
      <MoleculeCardTitle title={title} description={description} />
      {helperAlert && <div>{helperAlert}</div>}
      <Select
        disabled={disabled || isLoading || !!businessEntitiesError}
        value={selectedBusinessEntity?.id?.toString()}
        onValueChange={(value) => {
          const selectedEntity = businessEntities?.entities.find(
            (entity) => entity.id.toString() === value
          );
          if (selectedEntity) {
            onSelectBusinessEntity(selectedEntity);
          } else {
            onSelectBusinessEntity(null);
          }
        }}
      >
        <SelectTrigger error={error}>
          <SelectValue placeholder="Select an entity">
            {selectedBusinessEntity?.generalCorporationInfo?.legalName ||
              'Select an entity'}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {businessEntities?.entities
            .filter((entity) => !hideEntities?.includes(entity.id))
            .filter((entity) => entity.generalCorporationInfo?.legalName)
            .map((entity) => (
              <SelectItem key={entity.id} value={entity.id.toString()}>
                {entity.generalCorporationInfo?.legalName}
              </SelectItem>
            ))}
        </SelectContent>
        {error && <InputErrorMessage message={error} />}
      </Select>
    </MoleculeCard>
  );
}
